import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type CardColumnProps = React.HTMLAttributes<HTMLDivElement>

const CardColumn: React.FC<CardColumnProps> = ({ className, ...props }) => {
  const classes = useStyles()

  return <div {...props} className={clsx(classes.root, className)} />
}

export default CardColumn
